<template>
   <!-- Page message (alerts shown on the page, not in a window) -->
   <AlertComponent
      v-if="alert && alert.pageOrModal == 'page'"
      :alertstatus="alert.alertstatus"
      :message="alert.alertMessage"
      :type="alert.alertType"
   />
   <!-- Loader -->
   <p v-show="tableData.isVisible" class="crud_table_loader_class" align="center">
      <img src="/img/loader2.gif" style="height: 80px" /><br />
      <span class="loading-message"> {{ tableData.loaderMessage }}{{ tableData.loaderValue }} </span>
   </p>
</template>

<script>
// Page alert + loader at the top of a table page:  <PageStatus :alert="defaultAlert" :table-data="tableData" />
import AlertComponent from "../ui/AlertComponent.vue";

export default {
   name: "PageStatus",
   components: { AlertComponent },
   props: {
      alert: { type: Object, default: null },
      tableData: { type: Object, required: true },
   },
};
</script>